import React from 'react';
import { ESymbolKey } from "@smartsheet/forms-model";
import Full from "./Full";
import Half from "./Half";
import Quarter from "./Quarter";
import ThreeQuarters from "./ThreeQuarters";
import EmptySignal from "./EmptySignal";
import { IconOptionImg } from "../../iconUtil";
var SignalIcon = function (_a) {
    var type = _a.type;
    var icon;
    switch (type) {
        case ESymbolKey.SIGNAL_5_100:
        case "Full":
            icon = React.createElement(Full, null);
            break;
        case ESymbolKey.SIGNAL_5_050:
        case "Half":
            icon = React.createElement(Half, null);
            break;
        case ESymbolKey.SIGNAL_5_075:
        case "Three Quarter":
            icon = React.createElement(ThreeQuarters, null);
            break;
        case ESymbolKey.SIGNAL_5_025:
        case "Quarter":
            icon = React.createElement(Quarter, null);
            break;
        case ESymbolKey.SIGNAL_5_000:
        case "Empty":
            icon = React.createElement(EmptySignal, null);
            break;
        default:
            break;
    }
    return !!icon ? (React.createElement(IconOptionImg, null, icon)) : null;
};
export default SignalIcon;
